<template>
  <div></div>
</template>

<script setup>
const props = defineProps({ keyword: { type: String, default: '' } })

const { $i18n } = useNuxtApp()
const searchTerm = computed(() => (props.keyword === '' ? 'search_term_string' : props.keyword))

useJsonld(() => ({
  '@context': 'http://schema.org',
  '@type': 'WebSite',
  name: `${$i18n.t('funnow_title')}`,
  author: 'Zoek Inc.',
  url: 'https://www.myfunnow.com/',
  potentialAction: {
    '@type': 'SearchAction',
    target: `https://www.myfunnow.com/search?keyword={${searchTerm.value}}`,
    'query-input': `required name=${searchTerm.value}`,
  },
}))
</script>
